import {freewallEventsTableName} from "./freewall.events.table.name";

export const eventsTableS3Prefix = `${freewallEventsTableName}/`;